import { Icon } from '@/src/shared/components/Icon';
import { Typography } from '@/src/shared/components/Typography';

import styles from './IndustryItem.module.scss';

import { IndustryItemProps } from './types';
import { Button } from '@/src/shared/components/Button';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

export const IndustryItem = ({ item }: IndustryItemProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Icon name={item.icon} fontSize={isMobile ? 26 : 32} />
      </div>
      <Typography
        variant="text"
        size={isMobile ? 'lg' : 'xl'}
        fontWeight="semibold"
        className={styles.title}
      >
        {item.title}
      </Typography>
      <Typography tag="span" variant="text" size="md" fontWeight="regular">
        {item.subTitle}
      </Typography>
      <Button
        variant={isMobile ? 'icon' : 'default'}
        color="link"
        href={item.link}
        endIcon="arrow-narrow-right"
      >
        {!isMobile && 'Learn More'}
      </Button>
    </div>
  );
};
